import React, { type JSX } from 'react';
import {} from 'styled-components';

import { Container } from './VisuallyHidden.styled';

interface Props {
    as?: React.ElementType | keyof JSX.IntrinsicElements;
    children?: React.ReactNode;
}

const VisuallyHidden: React.FC<Props> = props => {
    const { children, as } = props;

    return <Container as={as ? as : undefined}>{children}</Container>;
};

export default VisuallyHidden;
